'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import ShowTile from '@/components/ShowTile';
import type { Event_Entry } from '@/lib/graphql-sdk';
import { cn } from '@/utils/cn';
import { filterEvents } from '@/utils/filterEvents';
import FilteredShowsFilter from '../FilteredShows/components/FilteredShowsFilter';
import Grid from '@/components/Grid';
import Section from '@/components/Section';

interface Filter {
    value: string;
    label: string;
}

interface FilteredShowsByCategoryProps {
    shows: Event_Entry[];
    locale: string;
    activeFilters?: string[];
    filterAction?: (filter: string) => void;
}

export default function FilteredShowsByCategory({
    shows,
    locale,
    activeFilters = [],
    filterAction = () => {},
}: FilteredShowsByCategoryProps): React.JSX.Element {
    const t = useTranslations('FilteredShows');
    const [results, setResults] = useState<Event_Entry[]>([]);

    const availableFilters: Filter[] = [{ value: 'english', label: t('only-english') }];

    useEffect(() => {
        setResults(filterEvents(shows, activeFilters) ?? {});
    }, [shows, activeFilters]);

    return (
        <Section variant="collection" background="haug-choco-100">
            <div className="relative z-30 bg-haug-ivory-30 mb-8">
                <FilteredShowsFilter
                    availableFilters={availableFilters}
                    activeFilters={activeFilters}
                    filterAction={filterAction}
                />
            </div>

            <Grid minColumns={1} maxColumns={4}>
                {results.map((event, index) => (
                    <ShowTile key={event.id} event={event} priority={index < 4} locale={locale}
                    className={'event-tile'}
                    />
                ))}
            </Grid>
        </Section>
    );
}
